/**
 * Consolidated styles for Click and Pledge components
 * Extracted from inline styles to comply with ESLint rules
 */

// AmazonPayButton styles
export const amazonPayButton = {
    buttonContainer: {
        position: 'relative'
    },

    amazonPayImage: {
        height: '11px'
    },

    loaderContainer: {
        display: 'flex'
    },

    modalOverlay: {
        display: 'flex',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
        alignItems: 'center',
        justifyContent: 'center'
    },

    modalDialog: {
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        maxWidth: '500px',
        width: '90%'
    },

    modalTitle: {
        marginBottom: '20px'
    },

    inputRow: {
        display: 'flex',
        gap: '12px',
        marginBottom: '12px'
    },

    inputWrapper: {
        flex: 1
    },

    inputField: {
        width: '100%',
        padding: '10px',
        borderRadius: '4px'
    },

    inputFieldDefault: {
        border: '1px solid #ccc'
    },

    inputFieldError: {
        border: '1px solid tomato'
    },

    errorText: {
        color: 'tomato',
        fontSize: '12px'
    },

    fullInputWrapper: {
        marginBottom: '12px'
    },

    errorBlock: {
        display: 'block',
        color: 'tomato',
        marginBottom: '12px',
        textAlign: 'center'
    },

    buttonRow: {
        display: 'flex',
        gap: '12px'
    },

    buttonBase: {
        flex: 1,
        padding: '10px 12px',
        border: 'none',
        borderRadius: '4px',
        fontSize: '14px'
    },

    buttonCancel: {
        backgroundColor: '#ccc',
        color: '#333',
        cursor: 'pointer'
    },

    buttonSubmit: {
        backgroundColor: '#006efe',
        color: '#fff'
    },

    buttonSubmitEnabled: {
        cursor: 'pointer'
    },

    buttonSubmitDisabled: {
        cursor: 'not-allowed',
        opacity: 0.7
    },

    paymentOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(255, 255, 255, 0.8)',
        zIndex: 5
    }
};

/**
 * Get combined styles for input field
 */
export const getInputFieldStyle = hasError => {
    return {
        ...amazonPayButton.inputField,
        ...hasError ? amazonPayButton.inputFieldError : amazonPayButton.inputFieldDefault
    };
};

/**
 * Get combined styles for submit button
 */
export const getSubmitButtonStyle = isLoading => {
    return {
        ...amazonPayButton.buttonBase,
        ...amazonPayButton.buttonSubmit,
        ...isLoading ? amazonPayButton.buttonSubmitDisabled : amazonPayButton.buttonSubmitEnabled
    };
};

/**
 * Get combined styles for cancel button
 */
export const getCancelButtonStyle = () => {
    return {
        ...amazonPayButton.buttonBase,
        ...amazonPayButton.buttonCancel
    };
};

// PaymentMethod styles
export const paymentMethod = {
    buttonRelative: {
        position: 'relative',
        marginBottom: '6px'
    },

    logoHeight: {
        height: '11px !important'
    },

    loaderVisible: {
        display: 'flex'
    },

    loaderHidden: {
        display: 'none'
    },

    noticeWrapper: {
        marginBottom: '5px'
    },

    labelStyle: {
        cursor: 'pointer'
    },
    refreshButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        transition: 'background-color 0.2s',
        color: '#333',
        marginLeft: 'auto'
    }
};

/**
 * Get loader display style based on loading state
 */
export const getLoaderStyle = isLoading => {
    if (isLoading) {
        return paymentMethod.loaderVisible;
    }

    return paymentMethod.loaderHidden;
};

// ConvenienceFee styles
export const convenienceFee = {
    feeRow: {
        display: 'flex',
        gap: '10px'
    }
};

// FooterSection styles
export const footerSection = {
    lockIcon: {
        fontSize: '0.75rem'
    }
};

export const CNPPopupOverlayStyles = {
    overlayText: {
        padding: '0 30px',
        fontWeight: '500',
        fontSize: '15px',
        color: '#fff'
    },
    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '20px'
    },
    spinner: {
        border: '4px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '50%',
        borderTop: '4px solid #fff',
        width: '40px',
        height: '40px',
        animation: 'spin 1s linear infinite'
    }
};
